import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as globalAdd from '../../../connectionString';
import { PaypalPromoCodeModal } from '../models/PaypalPromocode.model';
@Injectable()
export class SaPaypalPromocodeServiceService {

  constructor(private http: HttpClient) { }
  getProductsList() {
    return this.http.get(globalAdd.Paneladdress + 'api/SA/Promotion/getProductsList');
  }
  addNewPromoCode(promoModel:PaypalPromoCodeModal) {
    return this.http.post(globalAdd.Paneladdress + 'api/SA/Promotion/addNewPromoCode', promoModel );
  }
  updatePromoCode(updateModel) {
    return this.http.post(globalAdd.Paneladdress + 'api/SA/Promotion/updatePromoCode',  updateModel );
  }

  getAllPromoCodes(pageNo: number, text: string) {
    return this.http.get(globalAdd.Paneladdress + 'api/SA/Promotion/getAllPromoCodes?pageNo='+pageNo+'&text='+text);
  }
  enableDisablePromoCode(id,isChecked){
    return this.http.post(globalAdd.Paneladdress + 'api/SA/Promotion/enableDisablePromoCode', { id: id ,isChecked:isChecked});
    // return this.http.get(globalAdd.Paneladdress + 'api/SA/Promotion/enableDisablePromoCode?id='+id+'&isChecked='+isChecked);
  }
  deletePromoCode(id){
    return this.http.post(globalAdd.Paneladdress + 'api/SA/Promotion/deletePromoCode', { id: id });
    // return this.http.get(globalAdd.Paneladdress + 'api/SA/Promotion/deletePromoCode?id='+ id );
  }
  getPromoHistory(promoId){
    return this.http.get(globalAdd.Paneladdress + 'api/SA/Promotion/getPromoHistory?promoId='+promoId);
  }
}
